const groupCreateButtonModalEquipService = {
  text: 'Crear Sección +'
};

export default groupCreateButtonModalEquipService;
